import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const ToggleBase = forwardRef(
  ({ id, name, className = '', defaultChecked, hasError = false, readOnly = false, ...props }, ref) => {
    return (
      <input
        type="checkbox"
        ref={ref}
        id={id}
        readOnly={readOnly}
        name={name}
        className={`
        toggle
        toggle-success
        ${className}
        ${hasError ? 'input-error' : ''}
        ${defaultChecked ? 'defaultChecked' : ''}

      `}
        {...props}
      />
    );
  },
);

ToggleBase.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  defaultChecked: PropTypes.bool,
  type: PropTypes.string,
  className: PropTypes.string,
  isDefault: PropTypes.bool,
  readOnly: PropTypes.bool,
  hasError: PropTypes.bool,
};

ToggleBase.displayName = 'ToggleBase';

export default ToggleBase;
